import Constant from '@/common/constant/Constant';
import { createChatPostFile } from '@/component/chatThread/handler/ChatPostHandler';
import { uploadFileToS3 } from '@/component/common/UploadFiles';
import { createChatPostAPI, createThumbNailForChatPost } from '@/service/chatPostService';
export const onSubmitUploadFile = async (
    file,
        API,
        corporationId,
        affiliationProject,
        ticketId,
        chatThreadId,
        currentClientId,
        setFileUploading,
       // setIsModalUploadFileError,
        setFileUploadList,
        keyFileAtS3,
        fileUpload,
        postType
) => {
    
    let currentTime = new Date();

    let createNewChatPostRequestDto = {
        createThreadData: {
            corporationId: corporationId,
            postType: postType,
            chatThreadId: chatThreadId,
            content: file.name,
            creatorId: currentClientId,
            fileUrl: keyFileAtS3,
            status: Constant.CHAT_POST_STATUS.UN_READ,
            affiliationProject: affiliationProject,
            fileSize: file.size,
            createdAt: currentTime,
            seq: currentTime.getTime() + '',
            clientUUId: currentClientId,
            ticketId: ticketId
        }
    };
    let uploadResult = await uploadFileToS3(setFileUploading, fileUpload, API, ).then(async (data) => {
        if (data) {
            const result = await createChatPostAPI(API, createNewChatPostRequestDto);
            createNewChatPostRequestDto.createThreadData.chatPostId = result.id;
            createNewChatPostRequestDto.type = Constant.ANONYMOUS_CHATBOT_ACTION.CREATE_THUMBNAIL
            createChatPostAPI(API, createNewChatPostRequestDto);
            return true;
        } else {
            // setIsModalUploadFileError(true);
            return false;
        }
    });
    return uploadResult;
};